import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-1.5" }
const _hoisted_2 = {
  key: 0,
  class: "aspect-square bg-gray-100 w-full flex rounded-xl overflow-hidden"
}
const _hoisted_3 = {
  key: 1,
  class: "aspect-square bg-red-50 w-full flex rounded-xl overflow-hidden"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "px-4 py-3"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_8 = {
  key: 1,
  class: "px-4 py-3"
}
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "Something went wrong when loading the metadata", -1)
const _hoisted_11 = {
  key: 2,
  class: "px-4 py-3"
}
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "flex flex-wrap -mx-2 -my-0.5" }
const _hoisted_14 = ["textContent"]
const _hoisted_15 = ["textContent"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Metadata", -1)

import { computed, toRefs } from 'vue';
import { NftMetadata } from '@/models';
import { useModal } from '@/composables';
import { arrayWrap } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    metadata: null,
    to: null,
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    name: null
  },
  setup(__props: any) {

const props = __props as { metadata: NftMetadata, to?: object, loading: boolean, error: boolean, name?: string }



const { open: openModal } = useModal();

const {
  metadata, to, loading, error, name,
} = toRefs(props);

const creators = computed(() => {
  if (!metadata.value.properties?.creators) return null;
  return arrayWrap(metadata.value.properties.creators);
});

return (_ctx: any,_cache: any) => {
  const _component_icon_loading = _resolveComponent("icon-loading")!
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_icon_diamond_four = _resolveComponent("icon-diamond-four")!
  const _component_nft_attributes = _resolveComponent("nft-attributes")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!
  const _component_icon_users = _resolveComponent("icon-users")!
  const _component_nft_creators = _resolveComponent("nft-creators")!
  const _component_icon_brackets_curly = _resolveComponent("icon-brackets-curly")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(to) ? 'router-link' : 'div'), {
    to: _unref(to),
    class: _normalizeClass(["block bg-white shadow-xl shadow-indigo-500/10 border border-gray-200 rounded-2xl", _unref(to) ? 'transition hover:border-indigo-400 hover:scale-105 hover:shadow-indigo-500/30' : ''])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_icon_loading, { class: "w-6 h-6 text-gray-500 animate-spin m-auto" })
            ]))
          : (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_icon_x, { class: "w-6 h-6 text-red-400 m-auto" })
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "aspect-square bg-gray-100 w-full rounded-xl border object-cover",
                src: _unref(metadata).image,
                alt: _unref(metadata).name,
                onerror: "this.src='/broken.svg';this.onerror='';"
              }, null, 8, _hoisted_4))
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h3", {
              class: "font-semibold",
              textContent: _toDisplayString(_unref(name) ?? 'Loading...')
            }, null, 8, _hoisted_6),
            (_unref(name))
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Loading..."))
              : _createCommentVNode("", true)
          ]))
        : (_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("h3", {
                class: "font-semibold text-red-700",
                textContent: _toDisplayString(_unref(name) ?? 'Error')
              }, null, 8, _hoisted_9),
              _hoisted_10
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("h3", {
                class: "font-semibold mb-2",
                textContent: _toDisplayString(_unref(metadata).name)
              }, null, 8, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                (_unref(metadata).attributes)
                  ? (_openBlock(), _createBlock(_component_base_dropdown, {
                      key: 0,
                      class: "mx-2 my-0.5",
                      "menu-class": "p-3 w-72"
                    }, {
                      default: _withCtx(({ toggleListeners }) => [
                        _createElementVNode("button", _mergeProps(_toHandlers(toggleListeners), { class: "group p-0.5 text-gray-500 flex items-center space-x-2 hover:text-gray-900" }), [
                          _createVNode(_component_icon_diamond_four, { class: "w-5 h-5 text-gray-400 group-hover:text-gray-700" }),
                          _createElementVNode("div", {
                            textContent: _toDisplayString(`${_unref(metadata).attributes.length} attribute${_unref(metadata).attributes.length === 1 ? '' : 's'}`)
                          }, null, 8, _hoisted_14)
                        ], 16)
                      ]),
                      menu: _withCtx(() => [
                        _createVNode(_component_nft_attributes, {
                          attributes: _unref(metadata).attributes
                        }, null, 8, ["attributes"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(creators))
                  ? (_openBlock(), _createBlock(_component_base_dropdown, {
                      key: 1,
                      class: "mx-2 my-0.5",
                      "menu-class": "p-3 w-72"
                    }, {
                      default: _withCtx(({ toggleListeners }) => [
                        _createElementVNode("button", _mergeProps(_toHandlers(toggleListeners), { class: "group p-0.5 text-gray-500 flex items-center space-x-2 hover:text-gray-900" }), [
                          _createVNode(_component_icon_users, { class: "w-5 h-5 text-gray-400 group-hover:text-gray-700" }),
                          _createElementVNode("div", {
                            textContent: _toDisplayString(`${_unref(creators).length} creator${_unref(creators).length === 1 ? '' : 's'}`)
                          }, null, 8, _hoisted_15)
                        ], 16)
                      ]),
                      menu: _withCtx(() => [
                        _createVNode(_component_nft_creators, { creators: _unref(creators) }, null, 8, ["creators"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(openModal)('sidepage-json-explorer', { title: 'NFT Metadata', subtitle: 'Explore the Token Metadata as defined by Metaplex.', json: _unref(metadata) })), ["stop","prevent"])),
                  class: "mx-2 my-0.5 group p-0.5 text-gray-500 flex items-center space-x-2 hover:text-gray-900"
                }, [
                  _createVNode(_component_icon_brackets_curly, { class: "w-5 h-5 text-gray-400 group-hover:text-gray-700" }),
                  _hoisted_16
                ])
              ])
            ]))
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})